module.exports = __webpack_public_path__ + "static/media/add.4318e6ca.png";